<template>
  <div class="seven-date-picker-container wd-w-full">
    <div class="weekday-bar wd-mb-1 wd-py-2 wd-flex wd-justify-between">
      <div v-for="(weekDate, idx) in weekDayForToday" :key="idx" class="weekday-box">
        <div>{{ weekDate.day }}</div>
        <v-btn
          class="weekly-btn mt-2"
          :variant="weekDate.isTag ? 'flat' : 'text'"
          :color="weekDate.isTag ? 'orange50' : 'black50'"
          elevation="0"
          size="x-small"
          icon
          @click="onClickStartDate(weekDate.value)"
        >
          <p class="date-text mb-0">{{ weekDate.date }}</p>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SevenDayPicker',
  components: {},
  props: {
    modelValue: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  data() {
    return {}
  },
  computed: {
    weekDayForToday() {
      return Array.apply(null, Array(7)).map((value, index) => {
        const momentDate = this.$dayjs().add(index, 'd')
        let dayIdx = momentDate.$W
        const dateFormat = momentDate.format('YYYY-MM-DD')
        dayIdx = dayIdx === 7 ? 0 : dayIdx

        return {
          isTag: this.modelValue === dateFormat,
          value: dateFormat,
          day: index === 0 ? this.$t('all_today') : this.$rt(this.$tm('shortday')[dayIdx]),
          date: momentDate.format('D'),
        }
      })
    },
  },
  watch: {},
  mounted() {},
  methods: {
    onClickStartDate(date) {
      this.returnValue(date)
    },
    returnValue(date) {
      this.$emit('update:modelValue', date)
    },
  },
}
</script>

<style scoped lang="scss">
.seven-date-picker-container {
  .weekday-bar {
    .weekday-box {
      color: $gray80;
      text-align: center;
    }
    .weekly-btn {
      font-size: 15px;

      // &:before {
      //   background-color: unset;
      // }

      .date-text {
        text-indent: 0.0099877em;
      }

      .best-off-peak {
        width: 4px;
        height: 4px;
        position: absolute;
        text-align: center;
        white-space: pre;
        bottom: -6px;
        background-color: $orange50;
        border-radius: 4px;
      }
    }
  }
}
</style>
<style lang="scss"></style>
